<template>
  <div class="m-return-to">
    <AtomLoadingPrimary :loading-text="$t('mReturnTo.message')"/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeReturnTo'
}
</script>
